import { Controller } from "@hotwired/stimulus"

// A number field whose value is named in the submit button and in the
// form's confirm ("Enrich next 25", "Send 25 wines to Claude?"), kept in
// step as the number changes. The templates carry %{n}; a value outside
// the field's min/max is clamped the way the server clamps it.
export default class extends Controller {
  static targets = ["input", "button"]
  static values = { buttonTemplate: String, confirmTemplate: String }

  update() {
    const min = Number(this.inputTarget.min || 1)
    const max = Number(this.inputTarget.max || Infinity)
    const n = Math.max(min, Math.min(max, Number(this.inputTarget.value) || min))
    this.buttonTarget.textContent = this.buttonTemplateValue.replace("%{n}", n)
    this.element.dataset.turboConfirm = this.confirmTemplateValue.replace("%{n}", n)
  }
}
